import config from 'config/config'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cancelConfirm, confirm } from 'redux/navigation'
import { Button, Header, Icon, Modal } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { modal, confirmationModalVisible } = state.navigation
  return { modal, confirmationModalVisible }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      confirm,
      cancelConfirm,
    },
    dispatch
  )
}

class ConfirmationModal extends React.Component {
  render() {
    /*
     modal: expects an object like
     {
     icon:    icon,   // icon object, see config.js
     text:    text,   // modal content (optional)
     title:   title,  // modal title
     button:  button, // button Text
     confirm:  function that will be called on confirm
     doNotDisplay: // just do the action, the requirement for the modal is not fulfilled (for dedup)
     }
     */

    // props
    const { modal, confirmationModalVisible } = this.props

    // actions
    const { confirm, cancelConfirm } = this.props
    let returnValue = false
    if (modal) {
      console.debug('ConfirmationModal:render:', { modal })
      if (modal.doNotDisplay) {
        modal.confirm && modal.confirm()
      } else {
        returnValue = (
          <Modal open={confirmationModalVisible} size="small" basic>
            <Header as="h1">
              <Icon {...modal.icon} />
              {modal.title}
            </Header>
            <Modal.Content content={modal.text} />
            <Modal.Actions>
              <Button
                inverted
                onClick={cancelConfirm}
                content={I18n.t('global.cancel')}
                icon={config.icons.modalCancel}
              />
              <Button
                negative={modal.negative}
                positive={!modal.negative}
                icon="checkmark"
                labelPosition="right"
                content={modal.button ? modal.button : I18n.t('global.yes')}
                onClick={() => {
                  modal.confirm && modal.confirm()
                  confirm()
                }}
              />
            </Modal.Actions>
          </Modal>
        )
      }
    }
    return returnValue
  }
}

ConfirmationModal = connect(mapStateToProps, mapDispatchToProps)(
  ConfirmationModal
)
export default ConfirmationModal



// WEBPACK FOOTER //
// ./src/components/admin/Helper/ConfirmationModal.jsx